import { getAuthCookie } from '@moodys/cre-cpm.functions.cookies';
import { ApiConfig, ApiOptions } from '../../models/config';

/**
 * The default configuration for the app.
 */
export const getDefaultConfig = (
  options: ApiOptions = {},
): ApiConfig => ({
  timeout: options.timeout ?? 100000,
  url: options.url ?? process.env.REACT_APP_API_BASE ?? '',
  disableRedirectOnUnauthorized: options.disableRedirectOnUnauthorized ?? false,
  token: options.token ?? getAuthCookie() ?? '',
});
